module.exports = __webpack_public_path__ + "358684b1db73bfe44d5e16a18baa907e.jpg";